import React from 'react';
import {Box, Button, Typography} from "@mui/material";
import DefaultFooter from "./DefaultFooter";
import DefaultAppBar from "./AppBar";
import {ArrowForward} from "@mui/icons-material";
import {Link} from "react-router-dom";
import Forest1 from "./images/forest1.jpg";

const Heading = (props) => {
    return (<Typography style={{
            fontFamily: 'Raleway',
            fontWeight: 'normal',
            fontSize: 80,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'flex',
            color: '#0984e3'
        }}>
            {props.children}
        </Typography>
    )
}

const SubHeading = (props) => {
    return (<Typography sx={{
        fontFamily: 'Raleway',
        paddingLeft: '10px',
        fontWeight: 'normal',
        fontSize: 24,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'flex',
        color: '#bdc3c7'
    }}>
        {props.children}
    </Typography>)
}

const Text = (props) => {
    return (<Typography style={{
            fontFamily: 'Raleway',
            paddingLeft: '10px',
            fontWeight: 'normal',
            fontSize: 16,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'flex'
        }}>
            {props.children}
        </Typography>
    )
}

const CenterBox = (props) => {
    return (<div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        verticalAlign: 'center',
        height: '100%',
    }}>
        <div style={{
            margin: '64px'
        }}>
            {props.children}
        </div>
    </div>)
}

const NotFound = () => {
    return (
        <div>
            <DefaultAppBar/>
            <div style={{
                display: "block",
                width: "100%",
                height: "20em",
                objectFit: "cover",
                objectPosition: "center",
                // backgroundImage: `url(${Forest1})`,
                backgroundImage: `linear-gradient(to bottom,
                  rgba(255, 255, 255, 0) 60%,
                  rgba(255, 255, 255, 0.5) 80%,
                  rgba(255, 255, 255, 1) 100%),
                  url(${Forest1})`,
                backgroundSize: "cover",
            }}/>
            <CenterBox>
                <Heading>Ooops!</Heading>
                <SubHeading>Error 404: Seite nicht gefunden</SubHeading>
                <Text>Sie sind hier, weil die Seite verschoben wurde oder sie nicht bzw. nicht mehr existiert</Text>
                <Box my='24px' display='flex' justifyContent='center'>
                    <Button variant="outlined" endIcon={<ArrowForward/>} component={Link} to='/'>Nach hause</Button>
                </Box>
            </CenterBox>
            <footer id="footer">
                <DefaultFooter/>
            </footer>
        </div>
    );
};

export default NotFound;